<template>
    <div>
        <div v-if="isShowImg === false" class="light m-1">
            <like-mark class="fav-light" :liked="audioItem.fav" @liked="onLiked" @unliked="onUnliked"></like-mark>
            <b-button @click="onButtonClick" class="btn btn-dark pr-4">
                {{ audioItem.buttonDesc }}
            </b-button>
        </div>
        <div class="boxbutton" @click="onButtonClick" v-else>
            <like-mark class="fav" :liked="audioItem.fav" @liked="onLiked" @unliked="onUnliked"></like-mark>
            <div :class="buttonClass">
                <img v-lazy="imagePath" />
            </div>
            <p v-show="isShowButtonDesc">{{ audioItem.buttonDesc }}</p>
        </div>
    </div>
</template>

<script>
import Global from '@/mixins/global'
import AudioSourcePlayable from '@/mixins/AudioSourcePlayable'
import store from '../store/store'
import LikeMark from '@/components/LikeMark'

export default {
    name: 'AudioButton',
    props: {
        audioItem: {
            type: Object
        },
        buttonType: {
            type: String
        },
    },
    data: function () {
        return {
            gifPlaying: false
        }
    },
    components: {
        LikeMark
    },
    mixins: [Global, AudioSourcePlayable],
    computed: {
        imagePath: function () {
            let path = this.audioItem.imgPath
            if (this.buttonType === 'normal') {
                path = './banner.jpg'
            }

            else if (this.audioItem.gifImgPath != null) {
                if (this.gifPlaying) {
                    path = this.audioItem.gifImgPath
                }
            }
            const imagePath = this.generateDataPath(path)
            return imagePath
        },
        buttonClass: function () {
            switch (this.buttonType) {
                case 'normal':
                    return 'normalbutton'
                case 'mini':
                    return 'minibutton'
                default:
                    return 'normalbutton'
            }
        },
        isShowButtonDesc: function () {
            switch (this.buttonType) {
                case 'normal':
                    return false
                case 'mini':
                    return true
                case 'button':
                    return false
                default:
                    return true
            }
        },
        isShowImg: function () {
            switch (this.buttonType) {
                case 'normal':
                    return true
                case 'mini':
                    return true
                case 'button':
                    return false
                default:
                    return true
            }
        },
    },
    methods: {
        onLiked: function () {
            store.favs.setFav(this.audioItem.serialId,store.getAllItems(),true)
            const buttonFavs = store.favs.getLovalStorageFavs()
            this.$localStorage.set('buttonFavs',buttonFavs)
        },
        onUnliked: function () {
            store.favs.setFav(this.audioItem.serialId,store.getAllItems(),false)
            const buttonFavs = store.favs.getLovalStorageFavs()
            this.$localStorage.set('buttonFavs',buttonFavs)
        },
        onButtonClick: function () {
            let gifStopFunc = null
            if (this.audioItem.gifImgPath != null) {
                this.gifPlaying = true
                const vueThis = this
                gifStopFunc = function() {
                    vueThis.gifPlaying = false
                }
            }
            if (store.getSelectMode()) {
                this.playSelected(this.audioItem, gifStopFunc)
                store.editControl.addEditControl(this.audioItem)
            } else {
                this.play(this.audioItem, gifStopFunc)
            }
        },
    },
}
</script>

<style scoped>
.boxbutton {
    position: relative;
    margin: 5px 3px;
}
.boxbutton p {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    -ms-transform: translate(-50%, 0%);
    -webkit-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);
    text-align: center;
    margin: 0;
    width: 90%;
    padding: 0px 0px;
    bottom: 8px;
    left: 50%;
    font-size: small;
    color: white;
}
.minibutton {
    margin: 0px;
    padding: 1px;
    border-radius: 10px;
    border: solid;
    border-width: 1px;
    background: linear-gradient(to right, #be93c1, #be93c1);
}
.normalbutton {
    margin: 0px;
    padding: 1px;
    border-radius: 10px;
    width: 60%;
    border: solid;
    border-width: 1px;
    background: linear-gradient(to right, #be93c1, #be93c1);
}
.minibutton img {
    width: 110px;
    height: 110px;
    margin: 0px;
    padding: 0px;
    border-radius: 10px;
}
.normalbutton img {
    height: auto;
    width: 100%;
    margin: 0px;
    padding: 0px;
    border-radius: 10px;
}
.light {
    position:relative;
}
.fav {
    position: absolute;
    left: 3px;
    top: 3px;
}
.fav-light {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translate(-15%,-50%);
}
</style>
